import {STORAGE_KEY} from 'new-constants/common.constants';
import Config from '../config';
import {initialState} from 'reducers/auth.reducer.ts';

const Auth5Key = 'wo_auth';
const Auth6Key = STORAGE_KEY + Config.BaseServerUrl;

function get5auth(serializedState) {
	let persistedState = null;

	try {
		persistedState = JSON.parse(serializedState);
	} catch (e) {
		return null;
	}

	if (persistedState?.authDatas) {
		return persistedState.authDatas;
	}

	return null;
}

function get6auth(serializedState) {
	let persistedState = null;

	try {
		persistedState = JSON.parse(serializedState);
	} catch (e) {
		return null;
	}

	if (persistedState?.state?.auth?.cache) {
		return Object.values(persistedState.state.auth.cache);
	}

	return null;
}

function getStateFromAuthDatas(authDatas) {
	if (!authDatas) return initialState;

	return {
		...initialState,
		cache: authDatas.reduce(
			(accum, authData) => ({
				...accum,
				[authData.appId]: authData,
			}),
			{}
		),
	};
}

export const getMigratedAuth = function getMigratedAuth() {
	const state6 = localStorage.getItem(Auth6Key);
	if (state6) {
		return getStateFromAuthDatas(get6auth(state6));
	}

	const state5 = localStorage.getItem(Auth5Key);
	if (state5) {
		return getStateFromAuthDatas(get5auth(state5));
	}
};
